import { DatePicker } from 'antd';
import React from 'react';
import moment from 'moment';
import { RangePickerProps } from 'antd/es/date-picker';
import { TimeRangePickerProps } from 'antd';

const { RangePicker } = DatePicker;

enum timeType {
  TIME_STAMP = 'timestamp',
  DATA_STRING = 'dateString',
}

type ValueType = { [key: string]: number | string } | undefined | null;

type TimestampRangePickerProps = Omit<RangePickerProps, 'value' | 'defaultValue' | 'onChange'> & {
  type?: timeType;
  fieldNames?: { start: string; end: string };
  value?: ValueType;
  defaultValue?: ValueType;
  showTime?: TimeRangePickerProps | Boolean;
  onChange?: (val: ValueType, dateStrings: [string, string]) => void;
};

function TimestampRangePicker(props: TimestampRangePickerProps) {
  const {
    value,
    type = timeType.TIME_STAMP,
    onChange = () => {},
    defaultValue,
    fieldNames = { start: 'start', end: 'end' },
    ...otherProps
  } = props;

  const format: any = (() => {
    if (props.format) {
      return props.format;
    } else if (props.showTime) {
      return 'YYYY-MM-DD HH:mm:ss';
    } else {
      return 'YYYY-MM-DD';
    }
  })();

  const pickerValue: RangePickerProps['value'] = value
    ? [moment(value[fieldNames.start]), moment(value[fieldNames.end])]
    : undefined;
  const defaultPickerValue: RangePickerProps['defaultValue'] = defaultValue
    ? [moment(defaultValue[fieldNames.start]), moment(defaultValue[fieldNames.end])]
    : undefined;

  const onPickerChange: RangePickerProps['onChange'] = (
    val: RangePickerProps['value'],
    dateStrings: [string, string]
  ) => {
    // 先根据format转成string，再转成moment，这个操作可以直接砍掉不需要的那部分时间
    // 例如YYYY-MM-DD，转换后的时间戳不会加上时分秒；YYYY-MM-DD hh:mm:ss, 转换后的时间戳不会加上毫秒；YYYY-MM-DD hh:mm:ss.S,转换后的时间戳保留1位毫秒
    if (val) {
      const _val: { [key: string]: number | string } = {};
      if (type == 'timestamp') {
        if (format == 'YYYY-MM-DD') {
          _val[fieldNames.start] = moment(val[0]?.format('YYYY-MM-DD 00:00:00')).valueOf();
          _val[fieldNames.end] = moment(val[1]?.format('YYYY-MM-DD 23:59:59')).valueOf();
        } else {
          _val[fieldNames.start] = moment(val[0]?.format(format)).valueOf();
          _val[fieldNames.end] = moment(val[1]?.format(format)).valueOf();
        }
      }
      if (type == 'dateString') {
        _val[fieldNames.start] = dateStrings[0];
        _val[fieldNames.end] = dateStrings[1];
      }
      onChange(_val, dateStrings);
    } else {
      onChange(val, dateStrings);
    }
  };

  return (
    //@ts-ignore
    <RangePicker value={pickerValue} defaultValue={defaultPickerValue} onChange={onPickerChange} {...otherProps} />
  );
}

TimestampRangePicker.TIME_STAMP = timeType.TIME_STAMP;
TimestampRangePicker.DATA_STRING = timeType.DATA_STRING;

export default TimestampRangePicker;
